import React from "react";
import Responsive from "ui/Responsive";
import BannerLargeDevices from "./BannerLargeDevices";
import BannerSmallDevices from "./BannerSmallDevices";
import { HeroSection } from "interfaces/content";

export type ContainerComponentProps = {
  backgroundSrc?: string;
};

export interface BannerProps {
  data: HeroSection["data"];
}

const Banner = ({ data }: BannerProps) => {
  return (
    <>
      <Responsive minWidth="1000px">
        <BannerLargeDevices data={data} />
      </Responsive>
      <Responsive maxWidth="1000px">
        <BannerSmallDevices data={data} />
      </Responsive>
    </>
  );
};

export default Banner;
